import { react2angular } from 'react2angular';
import app from '../../../browser/addform/scripts/app';
import { AuthWidget } from './AuthWidget';

app.component('authWidget', react2angular(AuthWidget, [], ['config', 'httpApi', 'logger', 'authService']));
